import { Directive, HostListener, ElementRef } from '@angular/core';
import { DataService } from '../../_services/data.service';

@Directive({
  selector: '[appNumberCurrencyFormatter]'
})
export class NumberCurrencyFormatterDirective {

  private el: ElementRef;

  constructor(el: ElementRef, private dataService: DataService) {
    this.el = el;
  }

  // Listen for the input event to also handle copy and paste.
  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    const formattedNum = this.el.nativeElement.value.replace(/[^0-9]/g, '').replace(/^0+/, '');
    if (!formattedNum) {
      return '';
    }
    // this.el.nativeElement.value = formattedNum;
    this.el.nativeElement.value = this.dataService.formatNumberAsINR(formattedNum);
  }
}
